import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66669e14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "find" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("找研友审核")
const _hoisted_3 = { class: "search-box" }
const _hoisted_4 = { class: "item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "审核状态：", -1))
const _hoisted_6 = { class: "input" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_8 = ["src", "onClick"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode("暂无图片")
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("暂无考试科目")
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("暂无标签")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("已通过")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("待审核")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("未通过")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("发布")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("拒绝")
const _hoisted_19 = { class: "pagination" }
const _hoisted_20 = { class: "dialog-footer" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("确认")

import { onMounted, ref } from "vue";
import { ElMessage } from "element-plus";
import { getFriendList, infoIsPass } from "../../config/interface";

interface UserInfo {
	unionid: string,
	uid: string,
	lifePhoto: string,
	phone: string,
	college: string,
	targetCollege: string,
	targetMajor: string,
	examSubject: Array<string>,
	tag: Array<string>,
	slogan: string,
	mindFriend: string,
	isPass: number
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let tableLoading = ref(false)	// 表格loading状态
let tableData = ref()	// 表格数据
let searchValue = ref()	// 搜索参数
// let pageSize = ref(10)	// 每页的大小
let currentPage = ref(1)	// 当前在哪一页
let totalNum = ref(0)	// 表格数据总数
let dialogVisible = ref(false)	// 是否显示对象框
let refuseValue = ref('')	// 拒绝理由
let flag = ref(true)	// 防审核通过的按钮二次点击
let flag2 = ref(true)	// 防拒绝的确认通过按钮二次点击
let unionid = ref('')	// 拒绝用户的uid

// 审核通过按钮
const handlePass = (item: UserInfo) => {
	if(flag.value) {
		if(item.unionid) {
			infoIsPass({unionid: item.unionid, isPass: 2}).then((res: any) => {
				if(res.data.code == 200 && res.status) {
					ElMessage.success(res.data.data)
					getUserList(currentPage.value, searchValue.value)
				} else {
					ElMessage.error(res.data.message)
				}
				flag.value = true
			}).catch(() => {
				flag.value = true
				ElMessage.error('操作失败')
			})
		} else {
			ElMessage.error('该用户没有uid，请刷新重试或联系开发人员')
		}
	}
	flag.value = false
}
// 拒绝按钮，弹窗对话框
const handleRefuse = (item: UserInfo) => {
	if(item.unionid) {
		unionid.value = item.unionid
		dialogVisible.value = true
	} else {
		ElMessage.error('该用户没有uid，请刷新重试或联系开发人员')
	}
}
// 筛选框内容变化
const handleChange = () => {
	getUserList(1, searchValue.value)
}
// 点击搜索按钮
const handleSearch = () => {
	console.log(searchValue.value);
}
// 切换页码
const handleCurrentChange = (value: number) => {
	currentPage.value = value
	getUserList(value, searchValue.value)
}
// 切换每页数量
const handleSizeChange = (value: number) => {
	// pageSize.value = value
	console.log(value);
	return
}
// 关闭对话框
const handleCloseDialog = () => {
	refuseValue.value = ''
	dialogVisible.value = false
}
// 点击对话框确认按钮
const handleRefuseConfirm = () => {
	if(flag2.value) {
		if(refuseValue.value == '') {
			ElMessage.error('拒绝理由不能为空');
		} else {
			infoIsPass({unionid: unionid.value, isPass: 1, refuseReason: refuseValue.value}).then((res: any) => {
				if(res.data.code === 200 && res.data.status) {
					ElMessage.success(res.data.data)
					flag2.value = true
					dialogVisible.value = false
					getUserList(currentPage.value, searchValue.value)
				} else {
					ElMessage.error(res.data.message)
				}
				refuseValue.value = ''
			}).catch(() => {
				ElMessage.error('操作失败')
				refuseValue.value = ''
				flag2.value = true
				dialogVisible.value = false
			})
		}
	}
	flag2.value = false
}
const handleShowImgDetail = (url: string) => {
	window.open(url);
};

// 获取用户列表
const getUserList = (pageNum: number, isPass: string) => {
	tableLoading.value = true
	getFriendList({pageNum, isPass}).then((res: any) => {
		if(res.data.code === 200 && res.data.status) {
			totalNum.value = res.data.data.total
			// pageSize.value = 10
			tableData.value = res.data.data.list
			tableLoading.value = false
		} else {
			ElMessage.error('获取研友列表出错')
			tableLoading.value = false
		}
	}).catch(() => {
		ElMessage.error('获取研友列表出错')
		tableLoading.value = false
		tableData.value = []
	})
}

onMounted(() => {
	getUserList(1, '')
})

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tag, { type: "success" }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_select, {
            modelValue: _unref(searchValue),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchValue) ? (searchValue).value = $event : searchValue = $event)),
            clearable: "",
            placeholder: "选择审核状态",
            onChange: handleChange
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "待审核",
                value: "0"
              }),
              _createVNode(_component_el_option, {
                label: "未通过",
                value: "1"
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: handleSearch
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      })
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _unref(tableData),
      border: "",
      style: {"width":"100%"},
      "max-height": "670"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          fixed: "",
          type: "index",
          align: "center",
          label: "序号",
          width: "60"
        }),
        _createVNode(_component_el_table_column, {
          fixed: "",
          prop: "uid",
          align: "center",
          label: "用户编号",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "lifePhoto",
          align: "center",
          label: "生活照",
          width: "120"
        }, {
          default: _withCtx((scope) => [
            (scope.row.lifePhoto)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "lifePhoto",
                  src: scope.row.lifePhoto,
                  alt: "",
                  onClick: ($event: any) => (handleShowImgDetail(scope.row.lifePhoto))
                }, null, 8, _hoisted_8))
              : (_openBlock(), _createBlock(_component_el_tag, {
                  key: 1,
                  type: "warning",
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "phone",
          align: "center",
          label: "手机号码",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          prop: "college",
          align: "center",
          label: "本科院校",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          prop: "targetCollege",
          align: "center",
          label: "目标院校",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          prop: "targetMajor",
          align: "center",
          label: "目标专业",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          prop: "examSubject",
          align: "center",
          label: "考试科目",
          width: "180"
        }, {
          default: _withCtx((scope) => [
            (scope.row.examSubject && scope.row.examSubject.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  (scope.row.examSubject[0])
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 0,
                        size: "large",
                        style: {"marginRight":"10px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(scope.row.examSubject[0]), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true),
                  (scope.row.examSubject[1])
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 1,
                        size: "large",
                        type: "success"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(scope.row.examSubject[1]), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true),
                  (scope.row.examSubject.length === 0)
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 2,
                        type: "warning",
                        size: "large"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "labelName",
          align: "center",
          label: "标签",
          width: "300"
        }, {
          default: _withCtx((scope) => [
            (scope.row.labelName && scope.row.labelName.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.labelName, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_tag, {
                      key: index,
                      size: "large",
                      style: {"marginRight":"4px","marginBottom":"4px"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]))
              : (_openBlock(), _createBlock(_component_el_tag, {
                  key: 1,
                  type: "warning",
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "learnSlogan",
          align: "center",
          label: "学习宣言",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          prop: "mindFriend",
          align: "center",
          label: "目标研友",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          fixed: "right",
          prop: "isPass",
          align: "center",
          label: "审核状态",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            (scope.row.isPass === 2)
              ? (_openBlock(), _createBlock(_component_el_tag, { key: 0 }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }))
              : (scope.row.isPass === 0)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    type: "success"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_el_tag, {
                    key: 2,
                    type: "danger"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  }))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          fixed: "right",
          prop: "stauts",
          align: "center",
          label: "操作",
          width: "180"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "default",
              disabled: scope.row.isPass === 2,
              onClick: ($event: any) => (handlePass(scope.row))
            }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 2
            }, 1032, ["disabled", "onClick"]),
            _createVNode(_component_el_button, {
              type: "danger",
              size: "default",
              disabled: scope.row.isPass === 2,
              onClick: ($event: any) => (handleRefuse(scope.row))
            }, {
              default: _withCtx(() => [
                _hoisted_18
              ]),
              _: 2
            }, 1032, ["disabled", "onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _unref(tableLoading)]
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(_component_el_pagination, {
        "page-sizes": [10],
        "page-size": 10,
        "current-page": _unref(currentPage),
        background: "",
        layout: "total, prev, pager, next, sizes",
        total: _unref(totalNum),
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["current-page", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _unref(dialogVisible),
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(dialogVisible) ? (dialogVisible).value = $event : dialogVisible = $event)),
      title: "请输入拒绝理由",
      width: "600px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_20, [
          _createVNode(_component_el_button, { onClick: handleCloseDialog }, {
            default: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: handleRefuseConfirm
          }, {
            default: _withCtx(() => [
              _hoisted_22
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: _unref(refuseValue),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(refuseValue) ? (refuseValue).value = $event : refuseValue = $event)),
          autosize: { minRows: 5 },
          type: "textarea",
          placeholder: "请输入拒绝理由"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})